import { useEffect, useRef, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { HomeIcon, ProductIcon, SearchIcon, copyToClipboard, ShareIcon, pageSharingMessage, CopyIcon, ShopIcon, OrderIcon, CartIcon, CrossIcon, PhoneIcon, LockIcon, DropDownIcon, path, slugify, ShieldIcon, InquiryIcon, LazyShareButtons } from '../../base'
import { InfoIcon } from '../../base/index'
import { useSelector } from 'react-redux'


function SideBar({ show, setShowSideBar }) {
    const sideBarBackdropRef = useRef(null)
    const [showCategoryOption, setShowCategoryOption] = useState(false)
    const cart_total_item = useSelector((state) => state.appSlice.cart_total_item)
    const category_options = useSelector((state) => state.appSlice.category_options)

    function hideCategoryOption() {
        setShowCategoryOption(false)
        setShowSideBar(false)
    }

    function hideSideBarOnClick(event) {
        if (sideBarBackdropRef.current && sideBarBackdropRef.current.contains(event.target)) {
            setShowSideBar(false)
        }
    }

    function hideSideBarOnpageChange(event) {
        setShowSideBar(false)
    }

    useEffect(() => {
        window.addEventListener('popstate', hideSideBarOnpageChange)
        document.addEventListener('click', hideSideBarOnClick)

        return () => {
            window.removeEventListener('popstate', hideSideBarOnpageChange)
            document.removeEventListener('click', hideSideBarOnClick)
        }
    }, [])



    return (
        <div className={`backdropContent sideBar ${show}`}>
            <div className='sideBarContent position-relative'>
                <div style={{ height: '50px' }} onClick={() => setShowSideBar(false)}><CrossIcon /></div>
                <div className=" sideBarLinks mt-0">
                    <NavLink to={path.home} onClick={() => setShowSideBar(false)} className='link h6'><HomeIcon /><span>Home</span></NavLink><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <a onClick={() => setShowCategoryOption(!showCategoryOption)} className='link h6'><ProductIcon /><span className='iconSpan w-100 justify-content-between pe-3'>Products <DropDownIcon style={{ width: '18px' }} /></span></a><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <div className={`categoryOptions ${showCategoryOption ? 'active' : ''}`} style={{}}>
                        {
                            category_options && category_options.map((item, index) => {
                                return <span key={index}>
                                    <NavLink to={item === 'all' ? `/p/shop/all/category/all/products/` : `/p/shop/all/category/${slugify(item)}/products/`} onClick={() => hideCategoryOption()} className='link h6'>{item === 'all' ? 'All Category Products' : item}</NavLink>  <hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                                </span>
                            })
                        }
                    </div>
                    <NavLink to={path.all_shop} onClick={() => setShowSideBar(false)} className='link h6'><ShopIcon /><span>Shops</span></NavLink><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <NavLink to={path.product_search} onClick={() => setShowSideBar(false)} className='link h6'><SearchIcon style={{ width: '19px' }} /><span>Search Products</span></NavLink><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <NavLink to={path.cart} onClick={() => setShowSideBar(false)} className='link h6 position-relative'><CartIcon /><span>Cart {cart_total_item}</span></NavLink><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <NavLink to={path.all_order} onClick={() => setShowSideBar(false)} className='link h6'><OrderIcon style={{ width: '15px', marginLeft: '4px', marginRight: '1px' }} /><span>Orders</span></NavLink><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <NavLink to={path.inquiry_cart} onClick={() => setShowSideBar(false)} className='link h6'><CartIcon /><span>Inquiry Cart</span></NavLink><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <NavLink to={path.all_inquiry} onClick={() => setShowSideBar(false)} className='link h6'><InquiryIcon style={{ width: '20px'}}/><span>All Inquiries</span></NavLink><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />                    
                    <NavLink to={path.about} onClick={() => setShowSideBar(false)} className='link h6'><InfoIcon style={{ width: '18px' }} /><span>About</span></NavLink><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <NavLink to={path.contact_us} onClick={() => setShowSideBar(false)} className='link h6'><PhoneIcon style={{ width: '19px' }} /><span>Contact Us</span></NavLink><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <NavLink to={path.policies} onClick={() => setShowSideBar(false)} className='link h6'><LockIcon style={{ width: '19px' }} /><span>Policies</span></NavLink><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <NavLink to={path.termsofservice} onClick={() => setShowSideBar(false)} className='link h6'><ShieldIcon style={{ width: '19px' }} /><span>Terms of Service</span></NavLink><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <div className='link h6' onClick={() => copyToClipboard(window.location.href)}><CopyIcon /><span>Copy Page Link</span></div><hr className='borderBottom m-aut' style={{ marginLeft: '7%', width: '90%' }} />
                    <div className='link h6 pb-0'><ShareIcon /><span>Share Page Link</span></div>
                    
                    <LazyShareButtons className='d-flex ps-4 gap-3 pt-3 pb-3' url={window.location.href} quote={pageSharingMessage} />
                    
                </div>
            </div>

            <div ref={sideBarBackdropRef} className='backdrop'></div>
        </div>
    )
}

export default SideBar